module.exports = __webpack_public_path__ + "img/dp-sy-lm23.476ec579.png";